export default "__VITE_ASSET__DeUGWwxB__"